import { Link } from "react-router-dom";

interface FooterProps {
  isLoggedIn?: boolean;
}

export const Footer = ({ isLoggedIn = false }: FooterProps) => {
  return (
    <footer className={isLoggedIn ? '' : 'bg-card border-t'} style={isLoggedIn ? { backgroundColor: '#F5F7F9' } : {}}>
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Spalte 1: Kontaktdaten */}
          <div className="space-y-4">
            <div className="flex items-center space-x-1">
              <div className="h-8 w-8 rounded-full bg-white p-1 flex items-center justify-center">
                <img 
                  src="/lovable-uploads/1960ff0f-8400-4424-b14a-073e7254caa8.png" 
                  alt="Audio Empire Logo"
                  className="h-full w-full object-contain"
                />
              </div>
              <h3 className="font-semibold text-lg text-foreground">Audio Empire</h3>
            </div>
            <div className="space-y-2 text-sm text-muted-foreground">
              <p>Saleway GmbH</p>
              <p>Schulhausgässli 4</p>
              <p>3098 Köniz</p>
              <p className="pt-2">
                <a href="mailto:info@salesangels.org" className="hover:text-foreground transition-colors">
                  info@salesangels.org
                </a>
              </p>
              <p>
                <a href="tel:+41315520702" className="hover:text-foreground transition-colors">
                  +41 31 552 07 02
                </a>
              </p>
            </div>
          </div>

          {/* Spalte 2: Wichtige Links */}
          <div className="space-y-4">
            <h3 className="font-semibold text-lg text-foreground">Navigation</h3>
            <div className="space-y-2 text-sm">
              <Link to="/" className="block text-muted-foreground hover:text-foreground transition-colors">
                Home
              </Link>
              <Link to="/publisher-werden" className="block text-muted-foreground hover:text-foreground transition-colors">
                Publisher werden
              </Link>
              <Link to="/funktionen" className="block text-muted-foreground hover:text-foreground transition-colors">
                Funktionen
              </Link>
              <Link to="/preise" className="block text-muted-foreground hover:text-foreground transition-colors">
                Preise
              </Link>
              <Link to="/login" className="block text-muted-foreground hover:text-foreground transition-colors">
                Login
              </Link>
            </div>
          </div>

          {/* Spalte 3: Rechtliches */}
          <div className="space-y-4">
            <h3 className="font-semibold text-lg text-foreground">Rechtliches</h3>
            <div className="space-y-2 text-sm">
              <Link to="/presse" className="block text-muted-foreground hover:text-foreground transition-colors">
                Presse
              </Link>
              <Link to="/impressum" className="block text-muted-foreground hover:text-foreground transition-colors">
                Impressum
              </Link>
              <Link to="/datenschutz" className="block text-muted-foreground hover:text-foreground transition-colors">
                Datenschutz
              </Link>
              <Link to="/cookie-richtlinien" className="block text-muted-foreground hover:text-foreground transition-colors">
                Cookie-Richtlinien
              </Link>
              <Link to="/agb" className="block text-muted-foreground hover:text-foreground transition-colors">
                AGB
              </Link>
              <Link to="/kontakt" className="block text-muted-foreground hover:text-foreground transition-colors">
                Kontakt
              </Link>
            </div>
          </div>

          {/* Spalte 4: Logos & Siegel */}
          <div className="space-y-4">
            <h3 className="font-semibold text-lg text-foreground">Sicherheit & Partner</h3>
            <div className="flex items-center justify-start">
              <img 
                src="/lovable-uploads/0e0ab202-b9e6-42a7-9aca-b167a0ca370d.png" 
                alt="Digistore24 Logo"
                className="h-24 w-auto object-contain"
              />
            </div>
          </div>
        </div>
        
        <div className="border-t mt-8 pt-8 text-center">
          <p className="text-sm text-muted-foreground">
            © 2024 Audio Empire - Saleway GmbH. Alle Rechte vorbehalten.
          </p>
        </div>
      </div>
    </footer>
  );
};